export default "__VITE_ASSET__BZMotH8c__"